import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';

import { skip, takeUntil } from 'rxjs/operators';

import { BaseComponent } from '../../components/inherited/base/base.component';
import { Store } from '@ngrx/store';
import * as FiltersSelectors from '../../../core/state/filters-state/filters.selectors';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
})
export class NotFoundComponent extends BaseComponent implements OnInit {
  type: 'logged' | 'public';

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private store: Store
  ) {
    super();
  }

  ngOnInit() {
    this.type = this.activatedRoute.snapshot.data.type;
    if (this.type === 'logged') {
      this.store
        .select(FiltersSelectors.search)
        .pipe(takeUntil(this.alive$), skip(1))
        .subscribe(() => {
          this.router.navigate(['/app/home/search']);
        });
    }
  }
}
